/// <amd-module name="CodeCoverage/CodeCoverageTab/Components/CodeCoverageFolderViewTree" />
import React = require("react");
import { VssComponent } from 'VSS/Platform/Layout';
import { ISimpleTableCell } from "VSSUI/Table";
import {  FolderCoverageData, FileCoverageData } from 'Test/common-util/Contracts/Test';
import { TreeItemProvider, ITreeItem, ITreeItemEx } from "VSSUI/Utilities/TreeItemProvider";
import { Tree, ITreeProps, ITreeColumn, renderExpandableTreeCell, renderTreeCell } from "VSSUI/TreeEx";
import * as Utils_String from 'VSS/Core/Util/String';

interface ICodeCoverageFolderViewDetails extends ISimpleTableCell {
    moduleName: string;
    coveredLines: number;
    totalLines: number;
    lineCoverage: string;
}

export interface ICodeCoverageFolderViewTreeProps {
   folderCoverageData: FolderCoverageData
}

export interface IFolderViewCodeCoverageDetailsListState {
    listItems: ITreeItem<ICodeCoverageFolderViewDetails>[]
}


export class CodeCoverageFolderViewTree extends VssComponent<ICodeCoverageFolderViewTreeProps, IFolderViewCodeCoverageDetailsListState> {
    private treeItemProvider: TreeItemProvider<ICodeCoverageFolderViewDetails>;
    private columns: ITreeColumn<ICodeCoverageFolderViewDetails>[];
    constructor(props: ICodeCoverageFolderViewTreeProps) {
        super(props);
        const items: ITreeItem<ICodeCoverageFolderViewDetails>[] = [];
        items.push(this.processFolderCoverageData(props.folderCoverageData));
        this.state = { listItems: items };
        this.treeItemProvider = new TreeItemProvider<ICodeCoverageFolderViewDetails>(this.state.listItems);
        this.columns = [
            { id: "moduleName", width: -100, name: "Name", renderCell: renderExpandableTreeCell },
            { id: "coveredLines", width: 300, name: "Covered Lines", renderCell: renderTreeCell },
            { id: "totalLines", width: 300, name: "Total Lines", renderCell: renderTreeCell },
            { id: "lineCoverage", width: 300, name: "Line Coverage", renderCell: renderTreeCell }
        ];
    }

    public componentDidUpdate(prevProps: ICodeCoverageFolderViewTreeProps, prevState: IFolderViewCodeCoverageDetailsListState) {
        super.componentDidUpdate(prevProps, prevState);
        if (this.props.folderCoverageData !== prevProps.folderCoverageData) {
            console.log("Previous state : ", prevProps.folderCoverageData);
            console.log("Current state :", this.props.folderCoverageData);
            this.treeItemProvider.clear();
            const items: ITreeItem<ICodeCoverageFolderViewDetails>[] = [];
            items.push(this.processFolderCoverageData(this.props.folderCoverageData));
            this.setState({ listItems : items });
            items.forEach((p) => this.treeItemProvider.add(p));
        }
    }

    public render(): JSX.Element {
        
        return (
            <div className="diag-dialog-full-height-width v-scroll-auto">
                <Tree
                    containerClassName="diag-dialog-full-height-width"
                    columns={this.columns}
                    itemProvider={this.treeItemProvider}
                    onToggle={this.onToggle}
                    scrollable={false}
                />
            </div>
        );
    }
    private onToggle = (event: React.SyntheticEvent<HTMLElement>, treeItem: ITreeItemEx<ICodeCoverageFolderViewDetails>) => {
        this.treeItemProvider.toggle(treeItem.underlyingItem);
    };

    private processFolderCoverageData(folderCoverageData: FolderCoverageData): ITreeItem<ICodeCoverageFolderViewDetails> {
        if (folderCoverageData == undefined || folderCoverageData == null) {
            return {} as ITreeItem<ICodeCoverageFolderViewDetails>;
        }
        var moduleName = folderCoverageData.name;
        var linesCovered = folderCoverageData.coverageStatistics.linesCovered | 0;
        var linesNotCovered = folderCoverageData.coverageStatistics.linesNotCovered | 0;
        var linesPartiallyCovered = folderCoverageData.coverageStatistics.linesPartiallyCovered | 0;
        var totalLines = linesCovered + linesNotCovered + linesPartiallyCovered;
        var lineCoverage = Utils_String.localeFormat("{0}%", (totalLines ? ((linesCovered / totalLines) * 100) : 0).toFixed(2));
        var folderViewChildItems: ITreeItem<ICodeCoverageFolderViewDetails>[] = [];

        if (folderCoverageData.folders && folderCoverageData.folders.length) {
            folderCoverageData.folders.forEach((childFolder) => {
                var dataFromChildFolders = this.processFolderCoverageData(childFolder);
                if (Object.keys(dataFromChildFolders).length != 0) {
                    folderViewChildItems.push(dataFromChildFolders);
                }
            });
        }
        if (folderCoverageData.files && folderCoverageData.files.length) {
            folderCoverageData.files.forEach((childFile) => {
                var dataFromChildFolders = this.processFileCoverageData(childFile);
                if (Object.keys(dataFromChildFolders).length != 0) {
                    folderViewChildItems.push(dataFromChildFolders);
                }
            });
        }

        return {
            childItems: folderViewChildItems,
            expanded: false,
            data: {
                moduleName: moduleName,
                coveredLines: linesCovered,
                totalLines: totalLines,
                lineCoverage: lineCoverage
            }
        };
    }

    private processFileCoverageData(fileCoverageData: FileCoverageData): ITreeItem<ICodeCoverageFolderViewDetails> {
        if (fileCoverageData == undefined || fileCoverageData == null) {
            return {} as ITreeItem<ICodeCoverageFolderViewDetails>;
        }
        var moduleName = fileCoverageData.name;
        var linesCovered = fileCoverageData.coverageStatistics.linesCovered | 0;
        var linesNotCovered = fileCoverageData.coverageStatistics.linesNotCovered | 0;
        var linesPartiallyCovered = fileCoverageData.coverageStatistics.linesPartiallyCovered | 0;
        var totalLines = linesCovered + linesNotCovered + linesPartiallyCovered;
        var lineCoverage = Utils_String.localeFormat("{0}%", (totalLines ? ((linesCovered / totalLines) * 100) : 0).toFixed(2));
        return {
            childItems: [],
            expanded: false,
            data: {
                moduleName: moduleName,
                coveredLines: linesCovered,
                totalLines: totalLines,
                lineCoverage: lineCoverage
            }
        };
    }


    
}
